import api from "../../api/axios";
import { API_ENDPOINTS } from "../../api/endpoints";
import { resolveAuthCompanyId } from "./authUtils";
import type { AuthUser } from "./types";

/**
 * Asks the server to raise this month's and next month's pending payments for
 * the company that just signed in.
 *
 * The legacy .NET login did this on every sign-in (Login.js →
 * /Login/InsertPendingPayment): a sub expense is a recurring commitment, and
 * its monthly bill only exists once something creates it. The React login never
 * made the call, so after sign-in moved here nothing raised the bills unless
 * somebody still opened the old application. The server call is idempotent, and
 * a daily schedule can do the same job - this keeps the legacy guarantee that a
 * user who signs in sees current bills even where the schedule is off.
 *
 * Fire and forget, on purpose: a failure here must never fail or delay a
 * sign-in. It is logged to the console and the next sign-in tries again.
 */
export const raisePendingPayments = (user: AuthUser | null | undefined): void => {
  const companyId = Number(resolveAuthCompanyId(undefined, user)) || 0;
  if (companyId <= 0) return;

  void api
    .post(API_ENDPOINTS.PENDING_PAYMENT.GENERATE, null, { params: { companyId } })
    .catch((error: unknown) => {
      // eslint-disable-next-line no-console
      console.warn("Pending payments could not be raised at sign-in", error);
    });
};
